/**
 * @file Homepage Industries Anniversary.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Homepage Industries Anniversary component.
 */
const vHpIndustriesAnniversary = () => {
	const hpIndustriesAnniversary = document.querySelector('.v-hp-industries-anniversary');

	if (!hpIndustriesAnniversary) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);
	const list = hpIndustriesAnniversary.querySelector('.v-hp-industries-anniversary__list');
	const industries = hpIndustriesAnniversary.querySelectorAll('.v-hp-industries-anniversary__item');
	const gradientBg = hpIndustriesAnniversary.querySelector('.v-hp-industries-anniversary__bg-gradient');
	const quote = hpIndustriesAnniversary.querySelector('.v-hp-industries-anniversary__quote-banner');
	const quoteBg = hpIndustriesAnniversary.querySelector('.v-hp-industries-anniversary__quote-bg');
	const industriesTl = gsap.timeline({
		scrollTrigger: {
			trigger: hpIndustriesAnniversary,
			endTrigger: list,
			start: 'top bottom-=10%',
			end: 'center center',
			scrub: true,
		},
		defaults: {
			ease: 'power1.out',
		}
	});

	[...industries].forEach((industry) => {
		industriesTl.from(industry, { y: 100 });
	});

	// bg tween
	gsap.from(gradientBg, {
		scale: .5,
		scrollTrigger: {
			trigger: list,
			start: 'center bottom',
			end: 'center center',
			scrub: true,
		},
	});

	// quote bg tween
	gsap.from(quoteBg, {
		scale: .9,
		scrollTrigger: {
			trigger: quote,
			start: 'top bottom-=10%',
			end: 'center center',
			scrub: true,
		},
	});
};

export default vHpIndustriesAnniversary;
